export default __webpack_public_path__ + "static/media/co7.e2e9763c.png";